import HookLoader from './HookLoader/HookLoader';
import useFetch from './useFetch';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

interface Props {
    setEnv: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResourceEnvironment = ({ setEnv }: Props) => {
    let utilUrl = baseUrl;
    const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
    const req = { "data": "MIXPANEL_TOKEN~MIXPANEL_ENABLED" };
    const { response, loading }: any = useFetch(url, req, setEnv);

    if (response) {
        !!!win["mixpanel_url"] && (win["mixpanel_url"] = `${baseUrl}/MobilyTheme4Resources/js/mixpanel-tracker.js`);
        !!!win["mixpanel_token"] && (win["mixpanel_token"] = response.MIXPANEL_TOKEN);
        !!!win["mixpanel_enabled"] && (win["mixpanel_enabled"] = response.MIXPANEL_ENABLED);
    }

    return (
        <>
            {loading && <HookLoader loading={loading} />}
        </>
    )
}

export default ResourceEnvironment